import moment from 'moment';

const dateSort = (dateA, dateB) => moment(dateA).diff(moment(dateB));

const defaultSort = (a, b) => {
	if (a < b) return -1;
	if (b < a) return 1;
	return 0;
};

export const Sorter = {
	DEFAULT: defaultSort,
	DATE: dateSort,
};

export const compareDate = (data1, data2) => {
	const date1 = new Date(data1);
	const date2 = new Date(data2);
	if (date1 > date2) {
		return 1;
	} else if (date1 < date2) {
		return -1;
	}
};

export const compareNumber = (data1, data2) => {
	const num1 = Number(data1);
	const num2 = Number(data2);
	if (num1 > num2) {
		return 1;
	} else if (num1 < num2) {
		return -1;
	}
};

export const compareString = (data1, data2) => {
	if (data1 > data2) {
		return 1;
	} else if (data1 < data2) {
		return -1;
	}
};

export const columnShorter = (a, b, cdata) => {
	const first_data = a[cdata.dataIndex];
	const sec_data = b[cdata.dataIndex];
	if (first_data && !sec_data) {
		return 1;
	}
	if (sec_data && !first_data) {
		return -1;
	}
	if (!sec_data && !first_data) {
		return 0;
	}
	if (['date', 'datetime', 'month'].includes(cdata.field_type)) {
		return compareDate(first_data, sec_data);
	} else if (['number', 'money'].includes(cdata.field_type)) {
		return compareNumber(first_data, sec_data);
	} else {
		return compareString(first_data, sec_data);
	}
};
